import { render, staticRenderFns } from "./RelatedProductListItem.vue?vue&type=template&id=fddccb5c&"
import script from "./RelatedProductListItem.vue?vue&type=script&lang=js&"
export * from "./RelatedProductListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports